import { Button, SxProps } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { PickersActionBarAction, MobileDatePicker } from "@mui/x-date-pickers";
import React, { ComponentProps, useState } from "react";

import { ariaLabel as ariaLabelConst } from "src/constants";
import { useFieldContext } from "src/hooks";

import { DatePickerToolbar } from "../../DatePicker/DatePickerToolbar";
import { DatePickerButtonStyle } from "../../DatePicker/styles";
import { FormControl } from "../FormControl";

interface Props extends ComponentProps<typeof FormControl> {
  ariaLabel?: string;
  ariaLabelledBy?: string;
  ariaDescribedBy?: string;
  clearable?: boolean;
  maxDate?: Date;
  minDate?: Date;
  placeholder?: string;
  sx?: SxProps<Theme>;
}

export const DatePickerField = ({
  label,
  ariaLabel,
  ariaLabelledBy,
  ariaDescribedBy,
  clearable,
  maxDate,
  minDate,
  placeholder,
  sx,
}: Props) => {
  const field = useFieldContext<Date | null>();
  const [open, setOpen] = useState(false);

  const actionBarActions: Array<PickersActionBarAction> = [];
  if (clearable) actionBarActions.push("clear");
  actionBarActions.push("cancel", "accept");

  return (
    <FormControl label={label}>
      <MobileDatePicker
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        label={label}
        value={field.state.value}
        onChange={field.handleChange}
        minDate={minDate}
        maxDate={maxDate}
        views={["year", "month", "day"]}
        slots={{
          toolbar: () => <DatePickerToolbar value={field.state.value} />,
          textField: () => (
            <Button
              onClick={() => setOpen(true)}
              id={field.name}
              aria-label={ariaLabel}
              aria-labelledby={ariaLabelledBy}
              aria-describedby={ariaDescribedBy}
              sx={DatePickerButtonStyle(field.state.meta.errors[0], field.state.value, sx)}
            >
              {field.state.value?.toLocaleDateString() || placeholder || label || "ex : 01/01/2020"}
            </Button>
          ),
        }}
        slotProps={{
          actionBar: {
            actions: actionBarActions,
          },
          dialog: {
            "aria-label": ariaLabel || ariaLabelConst.datePickerDialog,
            "aria-labelledby": ariaLabelledBy,
          },
          mobilePaper: {
            "aria-label": ariaLabel || ariaLabelConst.datePickerDialog,
            "aria-labelledby": ariaLabelledBy,
          },
          switchViewButton: {
            "aria-label": ariaLabelConst.datePickerSwitchViewButton,
          },
          leftArrowIcon: {
            "aria-label": ariaLabelConst.datePickerLeftArrowIcon,
          },
          rightArrowIcon: {
            "aria-label": ariaLabelConst.datePickerRightArrowIcon,
          },
        }}
      />
    </FormControl>
  );
};
